//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapState } from 'vuex'
import { Breadcrumbs } from '~/plugins/breadcrumbs'
import { asyncDataCatch, asyncDataStart } from '~/utils/asyncData'
import { CACHE_SETTINGS } from '~/utils/cache'
import { getReviews } from '~/utils/server'

import OffersInMailbox from '~/components/section/offers-in-mailbox.vue'
import { capitalizeFirstLetter, dcopy } from '~/utils/utils'
import AdminSections from '~/components/admin-sections/admin-sections.vue'
import SeoSailingHolidays from '~/components/seo/sailing-holidays.vue'
import FaqItems from '~/components/Flotillas/FaqItems.vue'
import RequestAction from '~/components/global/RequestAction.vue'
import adminSectionPage from '~/mixins/admin-section-page'
import urlTranslator from '~/middleware/url-translator'
import OtherLocations from '~/components/seo/other-locations.vue'
import SearchComponent from '~/components/search/page/search-component.vue'
import PageTop from '~/components/section/page-top.vue'
import searchUtils from '~/mixins/search/search-utils'

export default {
  name: 'BoatRental',
  components: {
    PageTop,
    SearchComponent,
    OtherLocations,
    RequestAction,
    FaqItems,
    SeoSailingHolidays,
    AdminSections,
    OffersInMailbox
  },
  mixins: [adminSectionPage, searchUtils],
  middleware: [urlTranslator],
  async asyncData (ctx) {
    await asyncDataStart(ctx)

    try {
      const lang = ctx.store.getters['lang/locale']

      const [page, reviews] = await Promise.all([
        ctx.$axios.get('/api/content-page?link=sailing-holidays&lang=' + lang),

        ctx.$cacheFetch({
          key: `pIndex-getReviews-locale=${lang}`,
          expire: CACHE_SETTINGS.baseTime
        }, async () => {
          return await getReviews(ctx, lang)
        })
      ])

      if (Object.keys(page?.data || {}).length === 0) {
        ctx.redirect(302, ctx.app.router.resolve({ name: 'destinations' }).href)
        return
      }

      await ctx.store.dispatch('setBreadcrumbs', Breadcrumbs.get(ctx.app.i18n, 'page', ctx.route, [{
        title: page?.data?.data?.title,
        url: ctx.route.fullPath
      }]))
      ctx.store.commit('SET_META_DATA', {
        title: page.data?.data.meta_title,
        meta: [
          { name: 'title', property: 'og:title', hid: 'title', content: page.data?.data.meta_title },
          { name: 'description', property: 'og:description', hid: 'description', content: page.data?.data.meta_description },
          { name: 'twitter:title', content: page.data?.data.meta_title },
          { name: 'author', content: 'Tubber' },
          { name: 'twitter:description', content: page.data?.data.meta_description }
        ],
        link: []
      })
      return {
        page: page.data,
        reviews
      }
    } catch (e) {
      return asyncDataCatch(ctx, e)
    }
  },
  data () {
    return {
      showAllButton: {
        sliceResults: 3,
        text: ''
      },
      adminSectionsPage: {
        sectionCustomOrder: {
          'gallery:0': 0
        }
      }
    }
  },
  head () {
    return {
      title: this.page?.data.meta_title,
      meta: [
        {
          hid: 'description',
          name: 'description',
          property: 'og:description',
          content: this.page?.data.meta_description
        }
      ]
    }
  },
  computed: {
    ...mapState({
      breakpoint: 'breakpoint',
      currentCurrency: state => state.lang.currentCurrency,
      loading: state => state.search.loading,
      location: state => state.search.locationFull,
      filters: state => state.search.filters,
      results: state => state.search.results
    }),
    ...mapGetters({
      currentCurrency: 'lang/currentCurrency',
      locale: 'lang/locale'
    }),
    getShowAllButton () {
      return {
        sliceCount: 3,
        text: this.$t('show-all') + ' ' + (this.amountResultsFound) + ' ' + this.$tc(`${this.$t('boat')} | ${this.$t('boats_low')}`, this.amountResultsFound),
        hrefLink: this.$Search.generateClientUrl()
      }
    },
    amountResultsFound () {
      return this.$options.filters.numberWithCommas(this.$store.state.search.amountResultsFound)
    },
    boatTypes () {
      return this.$store.state.search.staticBoatTypes.map((t) => {
        return {
          ...t,
          name: t.translate ? capitalizeFirstLetter(this.$t(t.name.toLowerCase())) : t.name
        }
      })
    },
    getPage () {
      if (!this.page) {
        return {}
      }

      const modifiedPage = dcopy(this.page)
      const featuredItems = []
      modifiedPage.sections = modifiedPage.sections?.map((s) => {
        if (s.sort_order === 3) {
          s.images = modifiedPage.galleries[0].images
          s.texts = [s]
          s.type = 'gallery-with-text'
        }

        if (s.type === 'feature-item') {
          featuredItems.push(s)
          return false
        }

        return s
      }).map((s) => {
        if (s.sort_order === 5) {
          s.type = 'feature-items'
          s.items = featuredItems
        }
        if (s.sort_order === 6) {
          s.type = 'blog-items'
          s.items = (modifiedPage.blogs || [])
        }
        return s
      }).filter(Boolean)

      modifiedPage.galleries = []

      return modifiedPage
    }
  },
  mounted () {
    this.createdMethod()
    this.$scrollTo({ y: 0 })
  },
  methods: {
    createdMethod () {
      this.$Search.setAttributeValue('location', 'croatia')
      this.$Search.setAttributeValue('limit_date', false)

      this.$Search.setAttributeValue('sortBy', '-premium_boat')
      this.$Search.search({ changeUrl: false })
    }
  },
  beforeRouteLeave (to, from, next) {
    this.$Search.resetAllAttributes()
    next()
  }
}
